import { mapStore } from 'stores/MapStore';

import Query from 'esri/tasks/query';
import QueryTask from 'esri/tasks/QueryTask';
import IdentifyTask from 'esri/tasks/IdentifyTask';
import IdentifyParameters from 'esri/tasks/IdentifyParameters';
import ImageServiceIdentifyTask from 'esri/tasks/ImageServiceIdentifyTask';
import ImageServiceIdentifyParameters from 'esri/tasks/ImageServiceIdentifyParameters';

export const esriQuery = (url, options) => {
  const task = new QueryTask(url);
  const query = new Query();
  Object.entries(options).forEach(([key, value]) => {
    query[key] = value;
  });

  if (!query.where) {
    query.where = '1=1';
  }
  return task.execute(query);
};

export const esriIdentify = (url, options) => {
  const { map } = mapStore.getState();

  const task = new IdentifyTask(url);
  const parameters = new IdentifyParameters();
  parameters.geometry = options.geometry;
  parameters.layerIds = options.layerIds;
  parameters.layerOptions = IdentifyParameters.LAYER_OPTION_ALL;
  parameters.tolerance = 0;
  parameters.returnGeometry = false;
  parameters.mapExtent = map.extent;
  return task.execute(parameters);
};

export const esriIdentifyImageService = (url, options) => {
  const task = new ImageServiceIdentifyTask(url);
  const parameters = new ImageServiceIdentifyParameters();
  parameters.geometry = options.geometry;
  return task.execute(parameters);
};
